// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".docs-section[data-v-496325b3]{position:relative;padding-top:20px}.docs-section>.title[data-v-496325b3]{font-size:16px;font-weight:500}.docs-section>.helper[data-v-496325b3]{padding:5px 0}.docs-section>.content[data-v-496325b3]{padding:10px 0;overflow:auto;width:calc(100vw - 500px)}\n", ""]);
// Exports
module.exports = exports;
